import { render, staticRenderFns } from "./StudentApplicationHistory.vue?vue&type=template&id=501f782f&scoped=true&"
import script from "./StudentApplicationHistory.vue?vue&type=script&lang=js&"
export * from "./StudentApplicationHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentApplicationHistory.vue?vue&type=style&index=0&id=501f782f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f782f",
  null
  
)

export default component.exports